import { useState, useEffect, useContext } from 'react'
import ContextStates from '../../context/ContextStates'
import { FaEye, FaPen } from 'react-icons/fa'
import axios from 'axios'
import { Url } from '../Url'
import Select from 'react-select';
import { useNavigate } from 'react-router-dom'

const ListadoPresupuestos = () => {
    const [presupuestos, setPresupuestos] = useState([])
    const [clientes, setClientes] = useState([])
    const [cliente, setCliente] = useState(0)
    const [total, setTotal] = useState(0)
    const [fechaInicio, setFechaInicio] = useState('')
    const [fechaFin, setFechaFin] = useState('')
    const { setVentaSelected, setFormView, setViewOpen, modify, setPresupuestoSelected } = useContext(ContextStates)
    const navigate = useNavigate();

    useEffect(() => {
        const consultaClientes = async () => {
            const formData = new FormData()
            //formData.append('idusuario', idUsuario)
            formData.append('busqueda', "")
            try {
                const response = await axios({
                    url: Url + 'api/listClientes.php',
                    method: 'POST',
                    data: formData,
                })
                setClientes(response.data.results);
            } catch (e) {
                console.log(e)
            }
        }
        consultaClientes()
    }, [modify])


    useEffect(() => {
        const calcTotal = () => {
            let t = 0;
            if (typeof presupuestos !== 'undefined') {
                presupuestos.forEach(element => {
                    t = t + parseInt(element.total)
                });
                setTotal(t)
            }
        }
        calcTotal()
    }, [presupuestos])

    useEffect(() => {
        const consultaVentas = async () => {
            const formData = new FormData()
            formData.append('fechainicio', fechaInicio)
            formData.append('fechafin', fechaFin)
            formData.append('cliente', cliente)
            formData.append('punto', 0)
            
            try {
                const response = await axios({
                    url: Url + 'api/listadoPresupuestos.php',
                    method: 'POST',
                    data: formData,
                })
                console.log(response)
                setPresupuestos(response.data.results)
            } catch (e) {
                console.log(e)
            }
        }
        consultaVentas()
    }, [fechaInicio, fechaFin, cliente, modify])

    const handleSelect = (item) => {
        setCliente(item.id)
        //console.log(item)
    }

    const handleView = (item) => {
        setVentaSelected(item)
        setFormView(77)
        setViewOpen(true)
    }

    const handleEdit = (item) => {
        setVentaSelected(item)
        //console.log("revisar estruct ",item)
        navigate("/presupuesto");
    }

    return (
        <div className="w-full py-5 md:px-2">
            <h2 className='mt-10 mb-5 text-gray-600 text-3xl text-center'>Presupuestos</h2>
            <div className="w-full md:w-11/12 mx-auto bg-slate-200 mt-5 mb-5 rounded-xl">
                <div className='w-full flex'>
                    <div className='w-1/2 p-1 md:p-3'>
                        <label htmlFor='fechainicio'>Fecha de Inicio</label>
                        <input type='date' className='w-full p-3 rounded-lg' id='fechainicio' placeholder='Fecha de Inicio' value={fechaInicio} onChange={(e) => setFechaInicio(e.target.value)} />
                    </div>
                    <div className='w-1/2 p-1 md:p-3'>
                        <label htmlFor='fechafin'>Fecha de Fin</label>
                        <input type='date' className='w-full p-3 rounded-lg' id='fechafin' placeholder='Fecha de Fin' value={fechaFin} onChange={(e) => setFechaFin(e.target.value)} />
                    </div>
                </div>
                <div className='w-full p-1 md:p-3'>
                    <Select
                        options={clientes}
                        placeholder="Seleccione Cliente"
                        onChange={(value) => handleSelect(value)}
                        name='sCliente'
                    />
                </div>
            </div>
            {typeof presupuestos !== 'undefined' && (
                <table className='w-full mx-auto'>
                    <thead>
                        <tr className='p-1 bg-blue-400 text-white text-center'>
                            <th>Nº</th>
                            <th>Fecha</th>
                            <th>Hora</th>
                            <th>Total</th>
                            <th>Cliente</th>
                            <th>Domicilio</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            presupuestos.map((item, index) => (
                                <tr key={index} className={`hover:cursor-pointer hover:bg-slate-200 border-b border-gray-200 text-center ${item.saldo && item.saldo > 0 && item.saldo === item.total ? 'bg-red-300' : item.saldo > 0 && item.saldo < item.total ? 'bg-orange-300' : index % 2 === 0 ? 'bg-white ' : 'bg-slate-100'} )`}>
                                    <td>{item.numeropresupuesto}</td>
                                    <td>{item.fecha}</td>
                                    <td>{item.hora}</td>
                                    <td>$ {parseFloat(item.total).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</td>
                                    <td>{item.cliente}</td>
                                    <td>{item.domicilio}</td>
                                    <td className='text-center'>
                                        <button className='bg-blue-600 hover:bg-blue-400 rounded p-1 text-white' onClick={() => handleView(item)}><FaEye /></button>
                                        <button className='bg-red-600 ml-2 hover:bg-blue-400 rounded p-1 text-white' onClick={() => handleEdit(item)}><FaPen /></button>
                                    </td>
                                </tr>
                            ))
                        }
                        <tr className='border border-gray-300 p-2 text-center font-bold bg-slate-50'>
                            <td>Total</td>
                            <td></td>
                            <td></td>
                            <td>${total.toLocaleString("es-AR", { maximumFractionDigits: 2 })}</td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            )}

        </div>
    )
}

export default ListadoPresupuestos